import { useAppSelector } from '../../store/hook';
import { selectProject } from '../../store/project/projectSlice';
import { EReduxState } from '../../store/enum';
import { route } from '../../route/Index';
import { Navigate } from 'react-router-dom';

interface IIsFulfilledProject {}

const isFulfilledProject = <T extends IIsFulfilledProject>(WrappedComponent: React.ComponentType<T>) => {
    return (_props: T) => {
        const project = useAppSelector(selectProject);
        if (project.status != EReduxState.fulfilled) {
            return <Navigate to={route.info} />;
        }
        return <WrappedComponent {..._props} />;
    };
};

export default isFulfilledProject;
